












































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, IResource, ObjectCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDeliverySacGuest from '@/components/filters/FilterDeliverySacPublic.vue'
import DeliverySacPublicRequest from '@/model/request/DeliverySacPublicRequest'
import FilterToggle from '@/components/FilterToggle.vue'
import itTrackingSlider from '@/components/itrack/ItTrackingSlider.vue'
import * as Helper from '@/helpers'
import {SacBostonFilterType} from '@/enums/SacBostonFilterType'

const metaInfo = () => ({
  title: $.t('view.reports.deliverySacPublic.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliverySacGuest, FilterToggle, itTrackingSlider},
})
export default class ReportsDeliverySacBostonPublicView extends Mixins(MixinFilter) {
  SacBostonFilterType = SacBostonFilterType

  filter = new DeliverySacPublicRequest()

  type: IResource | null = null
  options = new ObjectCollection(SacBostonFilterType, 'enums.SacBostonFilterType')
    .prependNull('view.reports.deliverySacPublic.selectDocType')

  @Watch('type', {deep: true})
  typeEvent() {
    this.filter = new DeliverySacPublicRequest()
  }

  submit() {
    if (!this.filter.isCleared) {
      const query = Helper.classToPlain(this.filter) as any

      this.$router.push({
        path: '/boston/result',
        query,
      })
    }
  }
}
